import React, { useState, useEffect } from 'react';
import axios from "../../lib/axios";
import TableComponent from './TicketDataTable';
import { useNavigate } from 'react-router-dom';

const columns = [
 
    { id: "TicketNo", label: "TicketNo", minWidth: 100 },
    { id: "CreatedDateStr", label: "Date", minWidth: 100  },
    { id: "Name", label: "RaisedBy",  minWidth: 100 },
    { id: "CategoryName", label: "Category", },
    { id: "SubCategoryName", label: "SubCategory",minWidth: 100  },
    { id: "ServiceName", label: "Service", minWidth: 100 },
    { id: "TicketSt", label: "Status",minWidth: 100 },
    { id: "Remark", label: "Remark", minWidth: 100  }
]; 

export default function TrackTicket() {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(15);
  const [searchTerms, setSearchTerms] = useState({});
  const [rows, setRows] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    fetchTicketData();
  }, []);

  const fetchTicketData= async () => {
    try {
      const response = await axios.post('TrnTicketing/GetTrnTicketDashBoard', {
        start: 0,
        PageSize: 0,
        SearchText: ""
    });
  
      if (response.data.Status === 0) {
        const formattedData = response.data.Data.map(item => ({
          ...item,
          TicketNo: item.TicketNo  || 'NA',
          CreatedDateStr: item.CreatedDateStr  || 'NA',
          RaisedBy: item.RaisedBy  || 'NA',         
          Status: item.IsActive ? 'Active' : 'Inactive',
        }));
        setRows(formattedData);
      } else {
        console.error('Error in response Ticket data:', response.data.Message);
      }
    } catch (error) {
      console.error('Error fetching Ticket data:', error);
    }
  };

  

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleClick = () => {
    navigate('/');
  };

//   const handleHomeClick = () => {
//     navigate('/ticket-dashboard');
//   };

  const handleSearchChange = (columnId, value) => {
    setSearchTerms((prev) => ({ ...prev, [columnId]: value }));
    setPage(0);
  };

  const filteredRows = React.useMemo(() => {
    return rows.filter((row) =>
      Object.entries(searchTerms).every(([columnId, term]) => {
        if (!term) return true;
        const value = row[columnId];
        return value?.toString().toLowerCase().includes(term.toLowerCase());
      })
    );
  }, [searchTerms, rows]);

//   const handleRowDoubleClick = (row) => {
//     navigate('/', { state: { EmailConfigId: row.EmailConfigId, mode: 'view' }});
//   };
  

//   const handleLocationClick = () => {
//     navigate('/masters/control-security');
//   };

  return (
    <TableComponent
      columns={columns}
      rows={rows}
      filteredRows={filteredRows}
      page={page}
      title="Control Security"
      titleMaster="Track Ticket"
      rowsPerPage={rowsPerPage}
    //   handleRowDoubleClick={handleRowDoubleClick}
      handleSearchChange={handleSearchChange}
      handleChangePage={handleChangePage}
      handleChangeRowsPerPage={handleChangeRowsPerPage}
      handleClick={handleClick}
    //   handleHomeClick={handleHomeClick}
    //   handleLocationClick={handleLocationClick}
    />
  );
}